export default "/images/vendor/flag-icons/flags/1x1/sx.svg?c3e3382c50cdc9150344ccedd2b7fa52";